/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type RemoveUserAddressMutationVariables = Types.Exact<{
  addressId: Types.Scalars['ID'];
}>;


export type RemoveUserAddressMutation = (
  { __typename?: 'Mutation' }
  & { removeUserAddress: Types.Maybe<(
    { __typename?: 'ValidatingOperationResult' }
    & Pick<Types.ValidatingOperationResult, 'successful'>
    & { errors: Types.Maybe<Array<(
      { __typename?: 'ValidationItem' }
      & Pick<Types.ValidationItem, 'messages'>
    )>> }
  )> }
);


export const RemoveUserAddressDocument = gql`
    mutation removeUserAddress($addressId: ID!) {
  removeUserAddress(addressId: $addressId) {
    successful
    errors {
      messages
    }
  }
}
    `;
export type RemoveUserAddressMutationFn = Apollo.MutationFunction<RemoveUserAddressMutation, RemoveUserAddressMutationVariables>;

/**
 * __useRemoveUserAddressMutation__
 *
 * To run a mutation, you first call `useRemoveUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserAddressMutation, { data, loading, error }] = useRemoveUserAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useRemoveUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserAddressMutation, RemoveUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserAddressMutation, RemoveUserAddressMutationVariables>(RemoveUserAddressDocument, options);
      }
export type RemoveUserAddressMutationHookResult = ReturnType<typeof useRemoveUserAddressMutation>;
export type RemoveUserAddressMutationResult = Apollo.MutationResult<RemoveUserAddressMutation>;
export type RemoveUserAddressMutationOptions = Apollo.BaseMutationOptions<RemoveUserAddressMutation, RemoveUserAddressMutationVariables>;